import React from "react";
import { Calendar } from "lucide-react";
import { format, parse, isValid } from "date-fns";

interface DateInputProps {
  selectedDate: string; // e.g., "03-06-2025"
  onDateChange: (date: string) => void;
  placeholder?: string;
}

export const DateInput: React.FC<DateInputProps> = ({
  selectedDate,
  onDateChange,
  placeholder = "Select date",
}) => {
  const today = new Date().toISOString().split("T")[0]; // "yyyy-MM-dd"

  // Convert "dd-MM-yyyy" → "yyyy-MM-dd" for <input type="date" />
  let inputValue = "";
  const parsedDate = parse(selectedDate, "dd-MM-yyyy", new Date());
  if (isValid(parsedDate)) {
    inputValue = format(parsedDate, "yyyy-MM-dd");
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value; // "yyyy-MM-dd"
    const parsed = parse(raw, "yyyy-MM-dd", new Date());
    if (isValid(parsed)) {
      const formatted = format(parsed, "dd-MM-yyyy"); // Convert back
      onDateChange(formatted);
    }
  };

  return (
    <div className="relative">
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
          <Calendar className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors duration-200" />
        </div>
        <input
          type="date"
          value={inputValue}
          onChange={handleChange}
          max={today}
          className="block w-full pl-10 pr-4 py-3 text-sm border border-gray-300 rounded-xl 
                     bg-white placeholder-gray-500 text-gray-900
                     focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
                     hover:border-gray-400 transition-all duration-200
                     shadow-sm hover:shadow-md focus:shadow-lg
                     appearance-none cursor-pointer"
          placeholder={placeholder}
        />
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"></div>
      </div>
    </div>
  );
};
